import { PRIMARY } from '../../styles';

export default {
  title: {
    backgroundColor: PRIMARY,
    color: 'white',
  },
  subTitle: {
    fontSize: 14,
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  body: {
    marginTop: 60,
  },
  content: {
    padding: 0,
  },
  // content: {
  //   paddingTop: 20,
  //   paddingLeft: 20,
  //   paddingRight: 20,
  // },
  titleContainer: {
    display: 'flex',
  },
  titleSubTitleContainer: {
    flex: 1,
  },
  flex: {
    display: 'flex',
    flex: 1,
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/ReduxDialog/styles.js